const ITEMS = [
  "دليل المسافر للحجوزات",
  "Travelers Guide",
  "وكالة سفر",
  "منطقة السيف — مملكة البحرين",
  "تواصلوا معنا لترتيب حجوزاتكم",
];

export const Marquee = () => (
  <div className="relative border-y border-slate-200 bg-[#F8F9FA] py-5 overflow-hidden" aria-hidden="true">
    <div className="marquee-track flex w-max items-center" dir="ltr">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {[...ITEMS, ...ITEMS].map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center whitespace-nowrap">
              <span className="font-display text-lg sm:text-xl text-slate-600 px-6">{item}</span>
              <span className="text-[#C80000] text-sm">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
